/* Common Imports */

import { Dialog, IconButton, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import CloseIcon from "@material-ui/icons/Close";
import React, { useMemo, useState } from "react";

/* Styles */
const useStyles = makeStyles((theme) => ({
  mainContainer: {
    margin: "2rem 0rem 2rem 0rem",
    [theme.breakpoints.down("lg")]: {
      padding: "0rem 2rem 0rem 2rem",
    },
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  timeButtonsContainer: {
    overflowX: "auto",
    display: "flex",
    width: "100%",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  timeButtons: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "0.5rem",
    width: "100%",
  },
  timeButton: {
    padding: "0.5rem 1rem",
    fontSize: "0.813rem",
    fontWeight: "400",
    color: "#693471",
    background: "#FFFFFF",
    border: "1px solid rgba(105, 52, 113, 0.32)",
    whiteSpace: "nowrap",
    borderRadius: "0.75rem",
    cursor: "pointer",
    transition: "all 0.3s ease",
    "&:hover": {
      background: "#693471",
      color: "#FFFFFF",
    },
  },
  activeTimeButton: {
    background: "#693471",
    color: "#FFFFFF",
  },
  imgContent: {
    width: "100%",
    objectFit: "contain",
    "& img": {
      transition: "opacity 0.3s ease-in-out",
    },
  },
  contentDiv: {
    width: "100%",
  },
  headingForContent: {
    fontWeight: 400,
    fontSize: "2rem",
    lineHeight: "2.5rem",
    marginBottom: "1rem",
  },
  subOne: {
    fontSize: "1rem",
    fontWeight: "400",
    lineHeight: "1.75rem",
    marginBottom: "0.5rem",
  },
  subHeading: {
    color: "#666666",
    lineHeight: "1.25rem",
    fontSize: "0.875rem",
  },
  heading: {
    width: "100%",
    color: "#693471",
    fontWeight: 600,
    fontSize: "2.125rem",
    lineHeight: "2.65rem",
    margin: "0rem 0rem 0.5rem 0rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.25rem",
      lineHeight: "2rem",
    },
    background: "-webkit-linear-gradient(180deg, #74378E 0%, #502761 100%)",
    "-webkit-background-clip": "text",
    "-webkit-text-fillColor": "transparent",
  },
  dialogContent: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    position: "relative",
    // backgroundColor: "rgba(0, 0, 0, 0.9)",
    overflow: "hidden", // Disable scrolling inside the dialog content
  },
  activeSectionName: {
    fontWeight: 600,
    fontSize: "1rem",
    color: "#693471",
  },
  closeButton: {
    marginLeft: "auto",
  },
  dialogImage: {
    width: "390px",
    objectFit: "contain",
    transition: "transform 0.3s ease",
  },
  arrowButton: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 10,
  },
  arrowButtonLeft: {
    left: theme.spacing(2),
    color: "#ffffff",
  },
  arrowButtonRight: {
    right: theme.spacing(2),
    color: "#ffffff",
  },
  closeicondiv: {
    // backgroundColor: "rgba(0, 0, 0, 0.9)",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(2),
  },
  imageColumn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    overflowY: "auto", // Allow vertical scrolling
    overflowX: "hidden", // Disable horizontal scrolling
    maxHeight: "100%",
    padding: theme.spacing(2),
    gap: theme.spacing(2),
  },
  imageWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    cursor: "pointer",
  },
  thumbnailImage: {
    width: "375px",
    height: "auto",
    objectFit: "conatain",
    borderRadius: "8px",
    transition: "transform 0.3s ease",
  },
  imageLabel: {
    textAlign: "left",
    color: "#212121",
    fontSize: "0.875rem",
    marginLeft: "1rem",
  },
  activeImageContainer: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
  },
}));

const FloorMobileViewSection = () => {
  const classes = useStyles();
  const [activeSection, setActiveSection] = useState("Basement");
  const [openDialog, setOpenDialog] = useState(false);
  const [activeImage, setActiveImage] = useState("");
  const [touchStartX, setTouchStartX] = useState(0);
  //   const [openImageDialog, setOpenImageDialog] = useState(false); // State for second dialog

  const sections = {
    Basement: {
      img: "images/icons/heavie/aboutus/Basement_1.webp",
      subOne: "All the parking you'll ever need",
      subHeading: "Exclusive electric car charging points with a double height ceiling for every apartment unit.",
    },
    "Ground Floor": {
      img: "images/icons/heavie/aboutus/First-Floor.webp",

      subOne: "Spacious apartments overlooking green spaces",
      subHeading: "Ground floor units give you an opportunity to step into your own private utopia anytime you want.",
    },
    "Typical Floor": {
      img: "images/icons/heavie/aboutus/Detailed-Floor_1.webp",
      subOne: "Spacious apartments with private balconies",
      subHeading: "Private residences, holistically planned that are in harmony with nature and its elements.",
    },
    Terrace: {
      img: "images/icons/heavie/aboutus/Top-Floor.webp",
      subOne: "Leisure Hub",
      subHeading:
        "Live the high life with an infinity swimming pool, barbecue area, bonfire area, yoga deck, gym and a party hall.",
    },
  };

  const currentSection = useMemo(() => sections[activeSection], [activeSection]);

  const handleImageClick = (img) => {
    setActiveImage(img); // Set the active image
    setOpenDialog(true); // Open the first dialog
  };

  const handleCloseDialog = () => {
    setOpenDialog(false); // Close the first dialog
    setActiveImage(""); // Reset the active image
  };

  //   const handleOpenImageDialog = () => {
  //     setOpenImageDialog(true); // Open the second dialog
  //   };

  //   const handleCloseImageDialog = () => {
  //     setOpenImageDialog(false); // Close the second dialog
  //   };

  const handleNextSection = () => {
    const sectionKeys = Object.keys(sections);
    const currentIndex = sectionKeys.indexOf(activeSection);
    const nextIndex = (currentIndex + 1) % sectionKeys.length;
    setActiveSection(sectionKeys[nextIndex]);
    setActiveImage(sections[sectionKeys[nextIndex]].img);
  };

  //  const handleTouchStart = (e) => {
  //   setTouchStartX(e.touches[0].clientX);
  // };

  // const handleTouchEnd = (e) => {
  //   const touchEndX = e.changedTouches[0].clientX;
  //   if (touchStartX - touchEndX > 50) {
  //     handleNextSection(); // Swipe left
  //   } else if (touchEndX - touchStartX > 50) {
  //     handlePreviousSection(); // Swipe right
  //   }
  // };

  const handlePreviousSection = () => {
    const sectionKeys = Object.keys(sections);
    const currentIndex = sectionKeys.indexOf(activeSection);
    const previousIndex = (currentIndex - 1 + sectionKeys.length) % sectionKeys.length;
    setActiveSection(sectionKeys[previousIndex]);
    setActiveImage(sections[sectionKeys[previousIndex]].img);
  };

  React.useEffect(() => {
    Object.values(sections).forEach((section) => {
      const img = new Image();
      img.src = section.img;
    });
  }, []);

  return (
    <React.Fragment>
      <div className={classes.mainContainer}>
        <Typography
          variant="h1"
          component="h1"
          className={classes.heading}
        >
          Floor plans
        </Typography>
        <div className={classes.timeButtonsContainer}>
          <div className={classes.timeButtons}>
            {Object.keys(sections).map((section) => (
              <button
                key={section}
                className={`${classes.timeButton} ${activeSection === section ? classes.activeTimeButton : ""}`}
                onClick={() => setActiveSection(section)}
              >
                {section}
              </button>
            ))}
          </div>
          <div className={classes.imgContent}>
            <img
              src={currentSection.img}
              alt={currentSection.subOne}
              className={classes.imgContent}
            />
          </div>
        </div>

        <div className={classes.contentDiv}>
          <Typography
            variant="h1"
            component="h1"
            className={classes.headingForContent}
          >
            {currentSection.heading}
          </Typography>
          <Typography
            variant="h3"
            component="h3"
            className={classes.subOne}
          >
            {currentSection.subOne}
          </Typography>
          <Typography
            variant="body2"
            component="span"
            className={classes.subHeading}
          >
            {currentSection.subHeading}
          </Typography>
        </div>
        <div className={classes.imgContent}>
          <img
            src={currentSection.img}
            alt={currentSection.heading}
            className={classes.imgContent}
            onClick={() => handleImageClick(currentSection.img)}
          />
        </div>
      </div>
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        className={classes.dialogcontainer}
        fullScreen
      >
        <IconButton
          className={classes.closeButton}
          onClick={handleCloseDialog}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
        <div
          className={classes.activeImageContainer}
          onTouchStart={(e) => setTouchStartX(e.touches[0].clientX)}
          onTouchEnd={(e) => {
            const touchEndX = e.changedTouches[0].clientX;
            if (touchStartX - touchEndX > 50) {
              handleNextSection();
            } else if (touchEndX - touchStartX > 50) {
              handlePreviousSection();
            }
          }}
        >
          <IconButton
            className={`${classes.arrowButton} ${classes.arrowButtonLeft}`}
            onClick={handlePreviousSection}
            aria-label="previous"
          >
            <ArrowBackIcon style={{ color: "#212121" }} />
          </IconButton>
          <div className={classes.innerdiv}>
            {/* <Typography
              variant="h1"
              component="h1"
              className={classes.activeSectionName}
              style={{ marginLeft: "1rem" }}
            >
              {activeSection}
            </Typography> */}
            <img
              src={activeImage}
              alt="Floor Plans"
              className={classes.dialogImage}
            />
          </div>
          <IconButton
            className={`${classes.arrowButton} ${classes.arrowButtonRight}`}
            onClick={handleNextSection}
            aria-label="next"
          >
            <ArrowForwardIcon style={{ color: "#212121" }} />
          </IconButton>
        </div>
      </Dialog>
    </React.Fragment>
  );
};

export default FloorMobileViewSection;
